import { variabilityByStage, STAGE_FULL, STAGES_ORDER, getScoreColor } from "@/lib/reportUtils";

export const VariabilityIndicator = ({ paramsByStage, scoreScale = 1 }) => {
  const vb = variabilityByStage(paramsByStage);
  return (
    <div data-testid="variability-indicator">
      <p className="text-[11px] text-[#617364] mb-2 italic">
        Parameter spread per stage. High variation indicates instability — a stage may have strong individual metrics but uneven overall performance.
      </p>
      <div className="space-y-1.5">
        <div className="grid grid-cols-[1fr_1fr_70px_70px_80px] gap-2 text-[9px] uppercase tracking-wider font-bold text-[#617364] border-b border-[#E0E6E1] pb-1">
          <div>Stage</div>
          <div>Min–Max Spread</div>
          <div className="text-right">Min</div>
          <div className="text-right">Max</div>
          <div className="text-right">Spread</div>
        </div>
        {STAGES_ORDER.filter((s) => vb[s]).map((s) => {
          const v = vb[s];
          return (
            <div key={s} className="grid grid-cols-[1fr_1fr_70px_70px_80px] gap-2 items-center py-1">
              <div className="text-[11px] text-[#1B291D]">{STAGE_FULL[s]}</div>
              <div className="relative h-4 bg-[#F8F9F8] rounded">
                <div className="absolute top-0 bottom-0 rounded"
                  style={{
                    left: `${v.min * 10}%`,
                    width: `${(v.max - v.min) * 10}%`,
                    background: `linear-gradient(90deg, ${getScoreColor(v.min)} 0%, ${getScoreColor(v.max)} 100%)`,
                    opacity: 0.6,
                  }} />
                <div className="absolute top-0 w-0.5 h-4 bg-[#1B291D]" style={{ left: `${v.min * 10}%` }} />
                <div className="absolute top-0 w-0.5 h-4 bg-[#1B291D]" style={{ left: `${v.max * 10}%` }} />
              </div>
              <div className="text-right text-[11px]" style={{ color: getScoreColor(v.min) }}>{(v.min * scoreScale).toFixed(2)}</div>
              <div className="text-right text-[11px]" style={{ color: getScoreColor(v.max) }}>{(v.max * scoreScale).toFixed(2)}</div>
              <div className="text-right text-[11px] font-semibold" style={{ color: v.spread >= 4 ? "#D32F2F" : v.spread >= 2 ? "#F57F17" : "#388E3C" }}>
                {(v.spread * scoreScale).toFixed(2)}{v.spread >= 4 ? " 🔴" : v.spread >= 2 ? " 🟡" : " 🟢"}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
